import { SITE_HG, COUNTRY } from '@/config';

const ADVANCED_HOSTING_DEDICATED_LINUX_URL_BY_BRAND = {
  br: `${SITE_HG}/servidor-dedicado`,
  cl: `${SITE_HG}/servidores-dedicados`,
  co: `${SITE_HG}/servidores-dedicados`,
  mx: `${SITE_HG}/servidores-dedicados`,
  ar: `${SITE_HG}/servidores-dedicados`,
  pe: `${SITE_HG}/servidores-dedicados`,
  bo: `${SITE_HG}/servidores-dedicados`,
  cr: `${SITE_HG}/servidores-dedicados`,
  do: `${SITE_HG}/servidores-dedicados`,
  ec: `${SITE_HG}/servidores-dedicados`,
  sv: `${SITE_HG}/servidores-dedicados`,
  pa: `${SITE_HG}/servidores-dedicados`,
  py: `${SITE_HG}/servidores-dedicados`,
  uy: `${SITE_HG}/servidores-dedicados`,
};

const ADVANCED_HOSTING_DEDICATED_WINDOWS_URL_BY_BRAND = {
  br: `${SITE_HG}/servidor-dedicado-windows`,
  cl: `${SITE_HG}/servidores-dedicados-windows`,
  co: `${SITE_HG}/servidores-dedicados-windows`,
  mx: `${SITE_HG}/servidores-dedicados-windows`,
  ar: `${SITE_HG}/servidores-dedicados-windows`,
  pe: `${SITE_HG}/servidores-dedicados-windows`,
  bo: `${SITE_HG}/servidores-dedicados-windows`,
  cr: `${SITE_HG}/servidores-dedicados-windows`,
  do: `${SITE_HG}/servidores-dedicados-windows`,
  ec: `${SITE_HG}/servidores-dedicados-windows`,
  sv: `${SITE_HG}/servidores-dedicados-windows`,
  pa: `${SITE_HG}/servidores-dedicados-windows`,
  py: `${SITE_HG}/servidores-dedicados-windows`,
  uy: `${SITE_HG}/servidores-dedicados-windows`,
};

const ADVANCED_HOSTING_VPS_URL_BY_BRAND = {
  br: `${SITE_HG}/servidor-vps`,
  cl: `${SITE_HG}/vps-hosting`,
  co: `${SITE_HG}/vps-hosting`,
  mx: `${SITE_HG}/vps-hosting`,
  ar: `${SITE_HG}/vps-hosting`,
  pe: `${SITE_HG}/vps-hosting`,
  bo: `${SITE_HG}/vps-hosting`,
  cr: `${SITE_HG}/vps-hosting`,
  do: `${SITE_HG}/vps-hosting`,
  ec: `${SITE_HG}/vps-hosting`,
  sv: `${SITE_HG}/vps-hosting`,
  pa: `${SITE_HG}/vps-hosting`,
  py: `${SITE_HG}/vps-hosting`,
  uy: `${SITE_HG}/vps-hosting`,
};

export const ADVANCED_HOSTING_DEDICATED_LINUX_URL = ADVANCED_HOSTING_DEDICATED_LINUX_URL_BY_BRAND[COUNTRY];
export const ADVANCED_HOSTING_DEDICATED_WINDOWS_URL = ADVANCED_HOSTING_DEDICATED_WINDOWS_URL_BY_BRAND[COUNTRY];
export const ADVANCED_HOSTING_VPS_URL = ADVANCED_HOSTING_VPS_URL_BY_BRAND[COUNTRY];
